const IntegralList = () => import('Views/integral/integral-list');
const IntegralDetail = () => import('Views/integral/integral-detail');
const IntegralAddEdit = () => import('Views/integral/integral-addEdit');

export default[
  { path: '/integral-list', component: IntegralList },
  { path: '/integral-detail/:id', component: IntegralDetail },
  { path: '/integral-add', component: IntegralAddEdit },
  { path: '/integral-edit/:id', component: IntegralAddEdit },
];



// WEBPACK FOOTER //
// ./src/router/integral.js